export default "__VITE_ASSET__4caee082__"